export function isPublicRoute(route) {
  const matched =
    Array.isArray(
      route?.matched
    )
      ? route.matched
      : [];

  return matched.some(
    record =>
      record?.meta?.public === true
  );
}
